import React, { useEffect,useState } from "react"
import "./css/home.css"
import { useNavigate } from "react-router-dom"
import Layout from "./layout/Layout"
import gameConfig from "../utils/gamesConfig"
import SwiperE2 from "./swiperE2"
import SwiperTopTen from "./swipertopten"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./css/carousel.css"
import { service,brandImages, footerImages,serviceName,PopupSub} from "../utils/constant"
import { useTranslation } from "react-i18next";
import { checkStatus,updateRenewalStatus } from '../services/user-api';

const Home = () => {
  const { t } = useTranslation("global");
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
   const [subStatus, setSubStatus] = useState(0);
    const [popup, setPopup] = useState(false);
  
     const handlePlayGame = (input) => {
        setPopup(false);
        const token = localStorage.getItem('token');
        if (!token) { navigate("/login");} 
        else {
          checkStatus().then((res) => {
             if(service==="mng" && res.data.data===206){setSubStatus(res.data.data);setPopup(true);} // validity expired
             else if(input!==null && input!==undefined && input.length>2) window.location.href =input;
             else navigate('/allGames');          
          })
          .catch((err) => {console.log(err);})}
      }

      const renewalStatus = async(input) => {
        await updateRenewalStatus({status:input}).then((res) => {  
            setPopup(false);          
            console.log(res);
        }).catch((err) => {
             setPopup(false);  
            console.log(err)
        });
      };

  const adventureGames = gameConfig.find((item) => item.category_name === "Adventure")
  
  const racingGames = gameConfig.find((item) => item.category_name === "Racing")
  const sportGames = gameConfig.find((item) => item.category_name === "Sports")
  const funnyGames = gameConfig.find((item) => item.category_name === "Funny")

  const actionGames = gameConfig.find((item) => item.category_name === "Action")
  const puzzleGames = gameConfig.find((item) => item.category_name === "Puzzle")
  const kidsGames = gameConfig.find((item) => item.category_name === "Kids")
  const androidGames = gameConfig.find(
    (item) => item.category_name === "Android"
  )

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    autoplay: true,
    autoplaySpeed: 1500,
    responsive: [
      {
        breakpoint: 768, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 2, // Show 2 slides at a time on mobile devices
          slidesToScroll: 2,
        },
      },
    ],
  }

  const topTenSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    responsive: [
      {
        breakpoint: 768, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 2, // Show 2 slides at a time on mobile devices
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1196, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 3, // Show 2 slides at a time on mobile devices
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1400, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 4, // Show 2 slides at a time on mobile devices
          slidesToScroll: 1,
        },
      },
    ],
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Layout>
      <div className="home_page">
        <section className="intro_part">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-5">
                <div className="intro_text_container">
                  {service==="mueg"?<h2>Muni <span>Game</span></h2>
                  :service==="mng"?<h2>MOOV <span>GAMES</span></h2>
                  :service==="mtg"?<h2>MOOV <span>GAMES</span></h2>
                  :<h2>UV <span>GAMES</span></h2>
                  }
                   <p>{service==="ogb" ?(
                    <>{t("portalText.ogbDesc")}<img className="ogMoney" src="/images/ogg.png" alt="UVGames" />{t("portalText.ogbDesc1")}</>
                    ):service==="mng"?(t("portalText.mngDesc")
                    ):service==="mtg"?(t("portalText.mtgDesc")
                    ):service==="mueg"?(t("portalText.muegDesc")
                    ):t("portalText.desc")
                    }
                    </p>
                  <button onClick={() => handlePlayGame('/allGames')}>
                    {t("portalText.play")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="brand_list">
          <div className="container">
            <div className="row align-items-center">
              {/* <div className='col-12 col-lg-4 d-none d-lg-block'>
                                <p>Trusted By Brands Worldwide:</p>
                            </div> */}
              <div className="col-12 col-lg-12">
                <Slider {...settings}>
                  {brandImages.map((image, index) => (
                    <img
                      key={`BrandSlide ${index + 1}`}
                      src={image}
                      alt={`Slide ${index + 1}`}
                    />
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </section>
        <section className="games_1">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SwiperE2 gameData={actionGames} playGame={handlePlayGame}/>
              </div>
              <div className="col-12">
                <SwiperE2 gameData={adventureGames} playGame={handlePlayGame}/>
              </div>
            </div>
          </div>
        </section>
        <section className="top_games">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-lg-8 title-style-three white-title::before">
                <center>
                  <h4>
                    {t("portalText.Top 10")}
                    <span> {t("portalText.Games")}</span>
                  </h4>{" "}
                  <img
                    className="line-image"
                    src="data:image/png;base64,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"
                  />
                </center>

                {/* for tablet and desktop  */}
                {/* <div className="row align-items-center mb-4 topten-tablet-desktop">
                    {top5Games.length > 0 &&
                      top5Games.map((game) => {
                        return (
                          <div className="col-12 col-sm-2" key={game.name}>
                            <div className="top_game_wrapper">
                              <a href={game.path}>
                                <div className="top_games_img">
                                  <img src={game.image} alt={game.name} />
                                </div>
                              </a>
                              <div className="top_game_title">{game.name}</div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                  <div className="row align-items-center topten-tablet-desktop">
                    {top10Games.length > 0 &&
                      top10Games.map((game) => {
                        return (
                          <div className="col-12 col-sm-2" key={game.name}>
                            <div className="top_game_wrapper">
                              <a href={game.path}>
                                <div className="top_games_img">
                                  <img src={game.image} alt={game.name} />
                                </div>
                              </a>
                              <div className="top_game_title">{game.name}</div>
                            </div>
                          </div>
                        );
                      })}
                  </div> */}
                {/* for mobile  */}
                <section className="games_10 topten-mobile">
                  <div className="container">
                    <div className="row">
                      <div className="col-12">
                        <SwiperTopTen playGame={handlePlayGame} />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div className="col-12 col-lg-4">
                <div className="just_gamer_img top-gamer-main-image">
                  <img
                    src="/images/just_gamer.png"
                    alt="gamer"
                    style={{ position: "relative", zIndex: 2 }}
                  />
                  <div className="just-gamers-circle-shape">
                    <img
                      src="data:image/png;base64,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"
                      alt="hero rotate line"
                    />
                    <img
                      src="data:image/png;base64,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"
                      alt="hero rotate"
                      className="rotateme"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="games_2">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SwiperE2 gameData={puzzleGames} playGame={handlePlayGame}/>
              </div>
              <div className="col-12">
                <SwiperE2 gameData={funnyGames} playGame={handlePlayGame}/>
              </div>
            </div>
          </div>
        </section>
        <section className="uv_played">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-md-4">
                <div className="uv_played_img">
                  <img src="/images/uv_soldier.png" alt="soldier" />
                </div>
              </div>
              <div className="col-12 col-md-8">
                <div className="uv_played_text">
                  <div className="uv_played_title">
                    {service==="mueg"?t("portalText.MuniGames")+" "+currentYear:t("portalText.UV Games")+" "+currentYear}
                  </div>
                  <a onClick={() => handlePlayGame('/allGames')}>
                    <button className="uv_played_btn">
                      {service==="mueg"?t("portalText.TryMuni")+" "+currentYear:t("portalText.Try UV")+" "+currentYear}
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="games_3">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SwiperE2 gameData={racingGames} playGame={handlePlayGame} />
              </div>
              <div className="col-12">
                <SwiperE2 gameData={kidsGames} playGame={handlePlayGame}/>
              </div>
            </div>
          </div>
        </section>
        <section className="games_4">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SwiperE2 gameData={sportGames} playGame={handlePlayGame}/>
              </div>
              {/* <div className='col-12'>
                                <SwiperEl title='arcade' />
                            </div> */}
            </div>
          </div>
        </section>
        <section className="games_4">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SwiperE2 gameData={androidGames} playGame={handlePlayGame}/>
              </div>
              {/* <div className='col-12'>
                                <SwiperEl title='arcade' />
                            </div> */}
            </div>
          </div>
        </section>
        <section className="brand_list brand_list_footer">
          <div className="container">
            <div className="row align-items-center">
              {/* <div className='col-12 col-lg-4 d-none d-lg-block'>
                                <p>Trusted By Brands Worldwide:</p>
                            </div> */}
              <div className="col-12 col-lg-12">
                <Slider {...topTenSettings}>
                  {footerImages.map((image, index) => (
                    <img
                      key={`FooterSlide ${index + 1}`}
                      src={image}
                      alt={`Slide ${index + 1}`}
                    />
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </section>
        <section className="footer_list">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="footer_container">
                  {t("portalText.Copyright") +currentYear+" "+serviceName}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
       {popup && <PopupSub subStatus={subStatus} redirectTo={renewalStatus} detail={t("portalText.RenewalConsent")} confirm={t("portalText.RenewalConsent1")} yes={t("portalText.YES")} no={t("portalText.NO")} />}
    </Layout>
  )
}

export default Home
